(function () {
  if (window.__fcRedirectHandlerInstalled === true) {
    return;
  }

  window.__fcRedirectHandlerInstalled = true;

  // Hide Sobefy accessories modal
  var style = document.createElement('style');

  style.textContent = `
    #sobefy__accesories-upsell-modal-popup,
    #sobefy__accesories-upsell-modal {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
    }
  `;

  document.head.appendChild(style);

  // Redirect only after theme.js successfully adds the product
  document.addEventListener('product:added', function (event) {
    var detail = event.detail || {};
    var btn = detail.button || null;

    var lightboxContainer =
      document.getElementById(
        'sobefy__accesories-upsell-modal'
      );

    var popupModal =
      document.getElementById(
        'sobefy__accesories-upsell-modal-popup'
      );

    if (lightboxContainer) {
      lightboxContainer.style.display = 'none';
      lightboxContainer.style.visibility = 'hidden';
      lightboxContainer.style.opacity = '0';
    }

    if (popupModal) {
      popupModal.style.display = 'none';
      popupModal.style.visibility = 'hidden';
      popupModal.style.opacity = '0';
    }

    var context =
  window.__lastAddToCartContext || null;

if (
  context &&
  context.expires &&
  context.expires <= Date.now()
) {
  window.__lastAddToCartContext = null;
  context = null;
}

var isFromAccessories =
  detail.fromAccessories === true ||
  (
    btn &&
    btn.closest &&
    btn.closest('.accessories_upsell')
  );

var isFromSample =
  detail.fromSample === true ||
  (
    btn &&
    btn.hasAttribute &&
    (
      btn.hasAttribute('data-is-sample') ||
      btn.hasAttribute('data-sample-order')
    )
  ) ||
  window.__isSampleOrder === true ||
  window.__preventCartRedirect === true;

var shouldPreventRedirect =
  context &&
  context.preventRedirect === true;

if (
  isFromAccessories ||
  isFromSample ||
  shouldPreventRedirect
) {
  window.__lastAddToCartContext = null;
  window.__lastAddToCartBtn = null;
  window.__isSampleOrder = false;
  window.__preventCartRedirect = false;

  return;
}

    var currentUrl = window.location.href;

    if (
      currentUrl.indexOf('/pages/add-to-cart') !== -1 ||
      currentUrl.indexOf('view=added-to-cart') !== -1
    ) {
      return;
    }

    var withAccessoriesUrl =
      '/pages/add-to-cart?view=added-to-cart';

    var noAccessoriesUrl = '/cart';

    if (btn && btn.dataset) {
      if (btn.dataset.redirectWithAccessories) {
        withAccessoriesUrl =
          btn.dataset.redirectWithAccessories;
      }

      if (btn.dataset.redirectNoAccessories) {
        noAccessoriesUrl =
          btn.dataset.redirectNoAccessories;
      }
    }

    var hasAccessories =
      btn &&
      btn.dataset &&
      btn.dataset.hasAccessories === 'true';

    window.location.href = hasAccessories
      ? withAccessoriesUrl
      : noAccessoriesUrl;
  });
})();